import React from "react";
import { BsCameraVideoFill, BsMicFill, BsGlobe } from "react-icons/bs";
import { BiNetworkChart } from "react-icons/bi";
import { MdCheckCircle, MdCancel } from "react-icons/md";
import "./SystemCheckDialog.css";

const SystemCheckDialog = ({
  deviceStatus,
  performDeviceCheck,
  isConnected,
  onClose,
  allRequirementsMet,
}) => {
  const systemRequirements = [
    {
      icon: <BsCameraVideoFill />,
      title: `Camera: ${
        deviceStatus.camera.available ? "Available" : "Unavailable"
      }`,
      subtitle: deviceStatus.camera.subtitle,
      status: deviceStatus.camera.available,
    },
    {
      icon: <BsMicFill />,
      title: `Microphone: ${
        deviceStatus.microphone.available ? "Available" : "Unavailable"
      }`,
      subtitle: deviceStatus.microphone.subtitle,
      status: deviceStatus.microphone.available,
    },
    {
      icon: <BsGlobe />,
      title: `Browser: ${
        deviceStatus.browser.available ? "Compatible" : "Incompatible"
      }`,
      subtitle: deviceStatus.browser.subtitle,
      status: deviceStatus.browser.available,
    },
    {
      icon: <BiNetworkChart />,
      title: `Network: ${
        deviceStatus.network.available ? "Connected" : "Disconnected"
      }`,
      subtitle: deviceStatus.network.subtitle,
      status: deviceStatus.network.available,
    },
  ];

  return (
    <div className="system-check-overlay">
      <div className="system-check-dialog">
        <div className="dialog-header">
          <h3>System Requirements Check</h3>
        </div>
        <div className="dialog-check-content">
          {/* System Requirements Section */}
          <div className="requirements-section">
            {systemRequirements.map((req, index) => (
              <div
                key={index}
                className={`requirement-item ${
                  req.status ? "available" : "unavailable"
                }`}
              >
                <div className="requirement-status">
                  {req.status ? <MdCheckCircle /> : <MdCancel />}
                </div>
                <div className="requirement-icon">{req.icon}</div>
                <div className="requirement-info">
                  <div className="requirement-title">{req.title}</div>
                  <div className="requirement-subtitle">{req.subtitle}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Requirements Status Section */}
          {allRequirementsMet && (
            <div className="requirements-status-section">
              <div className="success-message">
                <MdCheckCircle />
                <span>All requirements met! Ready to proceed.</span>
              </div>
            </div>
          )}

          {/* Action Buttons Row */}
          <div className="action-buttons-row">
            <div className="retry-check-button">
              <button className="sys-check-button" onClick={performDeviceCheck}>
                <BiNetworkChart /> Retry Check
              </button>
            </div>

            <div className="proctor-status-button">
              <div
                className={`status-message ${
                  isConnected ? "connected" : "connecting"
                }`}
              >
                {isConnected
                  ? "Connected to proctor"
                  : "Waiting for proctor to join..."}
              </div>
            </div>
          </div>
        </div>
        <div className="dialog-footer">
          <button
            className="continue-button"
            onClick={onClose}
            disabled={!allRequirementsMet}
          >
            {allRequirementsMet
              ? "Continue to Exam"
              : "Please Fix Issues Above"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SystemCheckDialog;
